import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7dd55eae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "nav"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "info"
};
const _hoisted_5 = {
  class: "name"
};
const _hoisted_6 = {
  class: "price"
};
const _hoisted_7 = {
  class: "fixed-btn"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/mdwxapp/luckycards/share_btn.png"
}, null, -1));
const _hoisted_9 = [_hoisted_8];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompEWM = _resolveComponent("CompEWM");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['collect-list-box render-hide-scroll', {
      'list-box-wx': $data.env.isWxApp()
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("strong", null, _toDisplayString($data.collect_name), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: "collect-item-box"
    }, [_createElementVNode("div", {
      class: "collect-item",
      onClick: $event => $options.goInfo(item.id)
    }, [_createElementVNode("img", {
      class: "img",
      src: `${_ctx.$imgUrlFilter(item.list_main_image_url, 1280)}`
    }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_6, "￥" + _toDisplayString(item.sale_price), 1)])], 8, _hoisted_2)]);
  }), 128)), !$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "back",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goBack && $options.goBack(...args))
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [!$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "share-btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.onShare && $options.onShare(...args))
  }, _hoisted_9)) : _createCommentVNode("", true)]), _createVNode(_component_CompEWM, {
    show: $data.showEWM,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $data.showEWM = $event)
  }, null, 8, ["show"])], 2);
}